import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import '../Styles/Login.scss';
import Logo from '../Images/ht_logo_final.png';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import useFetch from '../CustomHooks/useFetch';
import { validateEmail } from '../Util/ValidateEmail';
import { setCookie, getCookie } from '../Util/Cookie';
import { GlobalContext } from '../Contexts/GlobalContext';


function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [response, fetchData] = useFetch();
    const globalContext = useContext(GlobalContext);
    const history = useHistory();
    const [errorMessages, setErrorMessages] = useState({ email: '', yourName: '', restaurantName: '', password: '', passwordAgain: '' });
    const [guiLanguage, setGuiLanguage] = useState('en');
    const [getCustomerSettingsHookResponse, getCustomerSettingsHook] = useFetch();


    useEffect(
        () => {
            if (window.location.href.indexOf('lang=tr') > 0) {
                setGuiLanguage('tr');
            }
        }, []
    )

    useEffect(
        () => {
          globalContext.dispatchMethod(
            {
              type: 'SET_MENU_LOCATION',
              value: {
                a: 0,
                b: 0
              },
            }
          )
    
        }
        , []
      )
    

    const setErrorMessage = (key, value) => {
        setErrorMessages({ ...errorMessages, [key]: value });
    }

    const submitForm = async (e) => {
        //e.preventDefault();

        let validated = true;

        if (!validateEmail(email)) {
            setErrorMessage('email', 'Please enter a valid email.');
            validated = false;
        }
        else {
            setErrorMessage('email', '');
        }

        if (validated) {
            fetchData(
                {
                    url: '/admin/auth/login',
                    method: 'POST',
                    postData: {
                        username: email,
                        password: password,
                    },
                }
            )
        }
    }

    useEffect(
        () => {
            /*
            globalContext.dispatchMethod({ type: 'SET_IS_LOGIN', value: true, });
            */

        }, []
    )

    const trimEmail = (email) => {
        let trimmedEmail = email.substring(0, email.indexOf('@') + 1);
        console.log(trimEmail);
        return trimmedEmail;
    }

    useEffect(
        () => {
            async function f() {
                console.log(response);
                if (response.fail == true) {
                    console.log('password hateli');
                    globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: guiLanguage=='tr'? 'Parola veya kullanıcı adı hatalı' : 'Wrong username or password', showButton: true } });
                }
                else {
                    if (response != null) {
                        if (response.length != 0) {
                            if (response) {
                                setCookie('token', response.tokenString, 30);


                                /*
                                let customerSettings = {
                                    email: trimEmail(response.user.email),
                                    alias: response.customerAlias,
                                    accountStatus: response.accountStatus,
                                    remainingTimeInDays: Math.floor(response.remainingTimeInDays),
                                };

                                
                                
                                    */

                                globalContext.dispatchMethod(
                                    {
                                        type: 'SET_EMAIL',
                                        value: trimEmail(response.user.email),
                                    });
                                
                                globalContext.dispatchMethod(
                                    {
                                        type: 'SET_ALIAS',
                                        value: response.customerAlias,
                                    });


                                

                                globalContext.dispatchMethod({ type: 'SET_IS_LOGIN', value: false, });
                                
                                getCustomerSettingsHook(
                                    {
                                        url: '/admin/customersettings',
                                        method: 'GET',
                                        addTokenHeader: true,
                                    }
                                )


                            }
                            else {
                                console.log('incorrect username or password!')
                            }
                        }
                    }
                }
            }
            f();
        }, [response]
    )

    useEffect (
        () => {
            if(getCustomerSettingsHookResponse.address) {

                globalContext.dispatchMethod(
                    {
                        type: 'SET_CUSTOMER_SETTINGS',
                        value: { ...getCustomerSettingsHookResponse },
                    });

                localStorage.setItem('ht_adm_cs', JSON.stringify(getCustomerSettingsHookResponse));

                history.push('/OpenOrders');
            }
        },[getCustomerSettingsHookResponse]
    )

    const handleKeyPress = (e) => {
        if (e.key == 'Enter') {
            submitForm();
        }
    }

    return (
        <div>
            <div className="login">
                <div className="login__inner-wrapper">
                    <img src={Logo} style={{ alignSelf: 'center', width: '250px', }}></img>
                    <TextField onKeyPress={handleKeyPress} id="username" label={guiLanguage == 'tr' ? 'e-posta adresiniz' : 'e-mail'} value={email} onChange={(e) => setEmail(e.target.value)} helperText={errorMessages.email} error={errorMessages.email == '' ? false : true} />
                    <TextField onKeyPress={handleKeyPress} id="password" type="password" label={guiLanguage == 'tr' ? 'parola' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} helperText={errorMessages.password} error={errorMessages.password == '' ? false : true} />
                    <Button id="submitButton" variant="contained" color="primary" style={{ marginTop: '30px' }} onClick={submitForm}>
                        {guiLanguage == 'tr' ? 'Giriş yap' : 'Login'}

                    </Button>
                    <div style={{ paddingTop: '20px', display: 'flex', justifyContent: 'flex-end', }}><a href={"/ForgotPassword?lang="+ guiLanguage} className="forgot-password-link">{guiLanguage == 'tr' ? 'Parolanızı unuttunuz mu?' : 'Forgot password?'}</a></div>
                </div>

            </div>
            <div className="login__not-a-customer">
                <div className="login__not-a-customer-inner-wrapper">
                    <span> {guiLanguage == 'tr' ? 'Üye değil misiniz?' : 'Not a customer?'}   </span>
                    <Button id="submitButton" variant="outlined" color="primary" style={{ marginTop: '0' }} onClick={() => window.location = 'https://admin.happytable.app/SignUp?lang=' + guiLanguage}>
                        {guiLanguage == 'tr' ? 'ÜCRETSİZ DENEYİN' : 'TRY FOR FREE'}
                    </Button>
                </div>
            </div>

        </div>
    );
}

export default Login;


